import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <blockquote>
      <p parentName="blockquote">{`This library was built by the community but it's being maintained by the PostHog core team since v1.0.0. Thank you to `}<a parentName="p" {...{
          "href": "https://github.com/nkezhaya"
        }}>{`Nick Kezhaya`}</a>{` for building it originally.`}</p>
    </blockquote>
    <p>{`The package can be installed by adding `}<inlineCode parentName="p">{`posthog`}</inlineCode>{` to your list of dependencies in `}<inlineCode parentName="p">{`mix.exs`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-elixir"
      }}>{`def deps do
  [
    {:posthog, "~> 1.1.0"}
  ]
end
`}</code></pre>
    <h3 {...{
      "id": "configuration"
    }}>{`Configuration`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-elixir",
        "metastring": "file=config/config.exs",
        "file": "config/config.exs"
      }}>{`config :posthog,
  api_url: "<ph_client_api_host>",
  api_key: "<ph_project_api_key>"

# Optional configurations
config :posthog,
  json_library: Jason,   # Default JSON parser (optional)
  enabled_capture: true, # Enable/disable PostHog tracking (optional, defaults to true)
  http_client: Posthog.HTTPClient.Hackney,  # Default HTTP client (optional)
  http_client_opts: [    # HTTP client options (optional)
    timeout: 5_000,      # Request timeout in milliseconds (default: 5_000)
    retries: 3,          # Number of retries on failure (default: 3)
    retry_delay: 1_000   # Delay between retries in milliseconds (default: 1_000)
  ]
`}</code></pre>
    <h4 {...{
      "id": "advanced-configuration"
    }}>{`Advanced configuration`}</h4>
    <p>{`The default JSON parser is `}<inlineCode parentName="p">{`Jason`}</inlineCode>{` but you can pass in a custom JSON library via the `}<inlineCode parentName="p">{`json_library`}</inlineCode>{` config.`}</p>
    <p>{`The default HTTP client is `}<inlineCode parentName="p">{`Hackney`}</inlineCode>{` but you can pass in a custom HTTP client via the `}<inlineCode parentName="p">{`http_client`}</inlineCode>{` config. This client should implement the `}<inlineCode parentName="p">{`Posthog.HTTPClient`}</inlineCode>{` behaviour. For testing purposes, you'll likely want a mock HTTP client implementation.`}</p>
    <p>{`You can refer to the library's `}<a parentName="p" {...{
        "href": "https://github.com/posthog/posthog-elixir"
      }}>{`README.md`}</a>{` for more information on the advanced configuration options.`}</p>
    <h4 {...{
      "id": "developmenttest-mode"
    }}>{`Development/Test mode`}</h4>
    <p>{`If you are running in development or test mode, you can pass in a `}<inlineCode parentName="p">{`enabled_capture: false`}</inlineCode>{` value to the config. This causes events to be dropped instead of sent to PostHog.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-elixir",
        "metastring": "file=config/test.exs",
        "file": "config/test.exs"
      }}>{`config :posthog,
  enabled_capture: false # Disable tracking in test mode
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      